import request from '@/utils/request'

export function getToken(data){
    return request({
        url: '/auth/tokenInfo',
        method: 'post',
        params:data
      })
}
export function login(data){
    return request({
        url: '/auth/doLogin',
        method: 'post',
        data:data
      })
}
export function userInfo(){
  return request({
      url: '/auth/getUserInfo',
      method: 'get',
      params:null
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js